// extracted by mini-css-extract-plugin
export var popper = "_41-0";
export var subtitle = "_41-1";